<p-dialog appDialogoPadrao="pi pi-users" descricao="Dados de acesso do usuário." [header]="titulo" [(visible)]="showDialog" [style]="{ width: modoEdicao ? '780px' : '680px' }" (onHide)="fechar()">
    <!-- Selecionar modo (apenas criação) -->
    @if (passo() === 'selecionar-modo') {
        <div class="flex flex-col gap-4 py-2">
            <p class="text-sm text-muted-color m-0">Como deseja adicionar o usuário ao portal?</p>
            <div class="grid grid-cols-2 gap-3">
                <button class="p-4 rounded-xl border-2 border-surface-200 dark:border-surface-600 hover:border-primary hover:bg-primary-50 dark:hover:bg-primary-900/20 transition-all text-left cursor-pointer" (click)="selecionarModo('vincular-sas')">
                    <i class="pi pi-link text-primary text-2xl mb-2 block"></i>
                    <div class="font-semibold text-sm mb-1">Vincular usuário existente</div>
                    <div class="text-xs text-muted-color">A pessoa já existe no sistema legado — como login, como funcionário, ou ambos. Busque pelo nome, CPF ou apelido para vincular ao portal.</div>
                </button>
                <button class="p-4 rounded-xl border-2 border-surface-200 dark:border-surface-600 hover:border-primary hover:bg-primary-50 dark:hover:bg-primary-900/20 transition-all text-left cursor-pointer" (click)="selecionarModo('criar-zero')">
                    <i class="pi pi-user-plus text-primary text-2xl mb-2 block"></i>
                    <div class="font-semibold text-sm mb-1">Criar usuário do zero</div>
                    <div class="text-xs text-muted-color">Cria cadastro completo: Solicitante, credenciais SAS e acesso ao portal em uma única operação.</div>
                </button>
            </div>
        </div>
    }

    <!-- Busca SAS existente -->
    @if (passo() === 'buscar-sas') {
        <div class="flex flex-col gap-3">
            <div class="flex items-center gap-2">
                <p-button icon="pi pi-arrow-left" ariaLabel="Voltar" severity="secondary" [text]="true" size="small" (onClick)="voltarParaModo()" pTooltip="Voltar" tooltipPosition="top" />
                <span class="text-sm font-medium">Buscar usuário SAS para vincular</span>
            </div>
            <app-pesquisa-usuario (selecionado)="onSasSelecionado($event)" />
        </div>
    }

    <!-- Formulário vincular (edição ou vincular-sas) -->
    @if (passo() === 'formulario-vincular' && formVincular) {
        @if (modoEdicao) {
            <p-tabs value="0">
                <p-tablist>
                    <p-tab value="0"><i class="pi pi-user mr-2"></i>Dados</p-tab>
                    <p-tab value="1">
                        <i class="pi pi-building mr-2"></i>Setores
                        @if (setores().length > 0) {
                            <span class="ml-2 px-1.5 py-0.5 text-xs font-bold rounded-full bg-primary text-white">{{ setores().length }}</span>
                        }
                    </p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="0">
                        <form [formGroup]="formVincular" class="flex flex-col gap-5 pt-2">
                            <!-- Foto + banner do usuário SAS selecionado -->
                            <div class="flex items-center gap-5">
                                <div class="relative shrink-0">
                                    <div class="w-24 h-24 rounded-full overflow-hidden border-4 border-surface-200 dark:border-surface-600 bg-surface-100 dark:bg-surface-800 flex items-center justify-center shadow-sm">
                                        @if (fotoBase64()) {
                                            <img [src]="fotoBase64()" alt="Foto de perfil" class="w-full h-full object-cover" />
                                        } @else {
                                            <i class="pi pi-user text-4xl text-muted-color opacity-40"></i>
                                        }
                                    </div>
                                    <label class="absolute bottom-0.5 right-0.5 w-8 h-8 rounded-full bg-primary shadow-md flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors" title="Alterar foto">
                                        <i class="pi pi-camera text-white text-sm"></i>
                                        <input type="file" accept="image/*" class="hidden" (change)="onFotoSelecionada($event)" />
                                    </label>
                                </div>

                                <div class="flex-1 flex flex-col gap-2">
                                    @if (usuario(); as u) {
                                        <div class="p-3 bg-surface-100 dark:bg-surface-800 rounded-lg">
                                            <span class="text-xs text-muted-color"
                                                >UF: <b>{{ u.ufSolicitante }}</b></span
                                            >
                                        </div>
                                    }
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-xs text-muted-color">Foto de perfil</span>
                                        <span class="text-xs text-muted-color/70">JPG, PNG ou GIF. Clique no ícone para alterar.</span>
                                        @if (fotoBase64()) {
                                            <p-button label="Remover" icon="pi pi-trash" severity="danger" [text]="true" size="small" styleClass="self-start -ml-2" (onClick)="removerFoto()" />
                                        }
                                    </div>
                                </div>
                            </div>

                            <p-divider styleClass="my-0" />

                            <div class="grid grid-cols-2 gap-4">
                                <div class="flex flex-col gap-1 col-span-2">
                                    <label class="text-sm font-medium">Nome do solicitante <span class="text-red-500">*</span></label>
                                    <input pInputText formControlName="nmSolicitante" placeholder="Nome completo" class="w-full" />
                                    @if (isInvalidV('nmSolicitante')) {
                                        <small class="text-red-500">Obrigatório (máx. 70 caracteres).</small>
                                    }
                                </div>

                                <div class="flex flex-col gap-1 col-span-2">
                                    <label class="text-sm font-medium">CPF</label>
                                    @if (!cpfEditavel()) {
                                        <div class="flex items-center gap-2">
                                            <input pInputText [value]="cpfFormatadoAtual()" [disabled]="true" class="flex-1" />
                                            <p-button label="Alterar CPF" icon="pi pi-pencil" severity="secondary" [text]="true" size="small" [appCan]="roleUsuariosEditar" (onClick)="habilitarEdicaoCpf()" />
                                        </div>
                                    } @else {
                                        <div class="flex items-center gap-2">
                                            <input pInputText [ngModel]="cpfInput()" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onCpfInput($event)" placeholder="000.000.000-00" class="flex-1" />
                                            <p-button icon="pi pi-times" ariaLabel="Cancelar" severity="secondary" [text]="true" size="small" pTooltip="Cancelar" (onClick)="cancelarEdicaoCpf()" />
                                        </div>
                                        <small class="texto-aviso"><i class="pi pi-exclamation-triangle mr-1"></i>Atenção: alterar o CPF também altera o login do usuário no Keycloak.</small>
                                        @if (cpfTocado() && !cpfNovoValido()) {
                                            <small class="text-red-500">CPF inválido.</small>
                                        }
                                    }
                                </div>

                                <div class="flex flex-col gap-1 col-span-2">
                                    <label class="text-sm font-medium">User ID (Keycloak) <span class="text-red-500">*</span></label>
                                    <input pInputText formControlName="userId" placeholder="UUID do usuário no Keycloak" class="w-full" />
                                    @if (isInvalidV('userId')) {
                                        <small class="text-red-500">Obrigatório (máx. 300 caracteres).</small>
                                    }
                                </div>

                                <div class="flex flex-col gap-1 col-span-2">
                                    <label class="text-sm font-medium">Biografia</label>
                                    <textarea pTextarea formControlName="dsBiografia" rows="2" placeholder="Breve descrição..." class="w-full resize-none"></textarea>
                                </div>

                                <div class="flex flex-col gap-1">
                                    <label class="text-sm font-medium">Status no Portal <span class="text-red-500">*</span></label>
                                    <p-select formControlName="inAtivo" [options]="opcoesStatus" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                                </div>
                            </div>

                            <ng-container [ngTemplateOutlet]="blocoAgr" />
                        </form>
                    </p-tabpanel>

                    <!-- ABA: SETORES -->
                    <p-tabpanel value="1">
                        <!-- Form de adição inline -->
                        <div class="flex flex-col gap-3 pt-2 pb-4 border-b border-surface-200 dark:border-surface-700">
                            <span class="text-sm font-semibold text-muted-color uppercase tracking-wide">Adicionar setor</span>
                            <div class="grid grid-cols-12 gap-2 items-end">
                                <div class="col-span-5 flex flex-col gap-1">
                                    <label class="text-xs font-medium">Estrutura <span class="text-red-500">*</span></label>
                                    <p-select [(ngModel)]="novoSetor.idEstrutura" [options]="opcoesEstruturas()" optionLabel="label" optionValue="value" placeholder="Selecione..." appendTo="body" class="w-full" />
                                </div>
                                <div class="col-span-4 flex flex-col gap-1">
                                    <label class="text-xs font-medium">Cargo</label>
                                    <p-select [(ngModel)]="novoSetor.idCargo" [options]="opcoesCargos()" optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true" appendTo="body" class="w-full" />
                                </div>
                                <div class="col-span-2 flex flex-col gap-1">
                                    <label class="text-xs font-medium">Status</label>
                                    <p-select [(ngModel)]="novoSetor.inStatus" [options]="opcoesStatus" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                                </div>
                                <div class="col-span-1 flex items-end">
                                    <p-button
                                        icon="pi pi-plus"
                                        ariaLabel="Adicionar"
                                        severity="primary"
                                        [loading]="adicionandoSetor()"
                                        [disabled]="!novoSetor.idEstrutura"
                                        [appCan]="roleUsuariosEditar"
                                        (onClick)="adicionarSetor()"
                                        pTooltip="Adicionar"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- Tabela de setores -->
                        @if (carregandoSetores()) {
                            <div class="flex justify-center py-6">
                                <i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i>
                            </div>
                        } @else {
                            <p-table [value]="setores()" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="260px" class="mt-3">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Estrutura</th>
                                        <th style="width: 160px">Cargo</th>
                                        <th style="width: 80px" class="text-center">Status</th>
                                        <th style="width: 80px" class="text-center">Ações</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-setor>
                                    <tr>
                                        @if (editandoSetor()?.idEstrutura === setor.idEstrutura) {
                                            <td class="font-medium text-sm">{{ setor.descricaoEstrutura || '#' + setor.idEstrutura }}</td>
                                            <td>
                                                <p-select [(ngModel)]="editandoSetor()!.idCargo" [options]="opcoesCargos()" optionLabel="label" optionValue="value" placeholder="Selecione..." [showClear]="true" appendTo="body" class="w-full" />
                                            </td>
                                            <td>
                                                <p-select [(ngModel)]="editandoSetor()!.inStatus" [options]="opcoesStatus" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                                            </td>
                                            <td class="text-center">
                                                <div class="flex justify-center gap-1">
                                                    <p-button icon="pi pi-check" ariaLabel="Salvar" severity="success" [text]="true" size="small" pTooltip="Salvar" (onClick)="salvarEdicaoSetor()" />
                                                    <p-button icon="pi pi-times" ariaLabel="Cancelar" severity="secondary" [text]="true" size="small" pTooltip="Cancelar" (onClick)="cancelarEdicaoSetor()" />
                                                </div>
                                            </td>
                                        } @else {
                                            <td class="font-medium text-sm">{{ setor.descricaoEstrutura || '#' + setor.idEstrutura }}</td>
                                            <td class="text-sm">{{ setor.dsCargo || '—' }}</td>
                                            <td class="text-center">
                                                <p-tag [value]="setor.inStatus" [severity]="setor.inStatus === 'S' ? 'success' : 'danger'" />
                                            </td>
                                            <td class="text-center">
                                                <div class="flex justify-center gap-1">
                                                    <p-button icon="pi pi-pencil" ariaLabel="Editar" severity="secondary" [text]="true" size="small" [appCan]="roleUsuariosEditar" pTooltip="Editar" (onClick)="iniciarEdicaoSetor(setor)" />
                                                    <p-button
                                                        icon="pi pi-trash"
                                                        ariaLabel="Remover"
                                                        severity="danger"
                                                        [text]="true"
                                                        size="small"
                                                        [appCan]="roleUsuariosEditar"
                                                        pTooltip="Remover"
                                                        [loading]="removendoSetorId() === setor.idEstrutura"
                                                        (onClick)="removerSetor(setor)"
                                                    />
                                                </div>
                                            </td>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="4" class="text-center text-muted-color py-8">
                                            <i class="pi pi-building text-3xl block mb-2 opacity-30"></i>
                                            Nenhum setor vinculado a este usuário.
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        }
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        } @else {
            <form [formGroup]="formVincular" class="flex flex-col gap-5 pt-2">
                <!-- Foto + banner do usuário SAS selecionado -->
                <div class="flex items-center gap-5">
                    <div class="relative shrink-0">
                        <div class="w-24 h-24 rounded-full overflow-hidden border-4 border-surface-200 dark:border-surface-600 bg-surface-100 dark:bg-surface-800 flex items-center justify-center shadow-sm">
                            @if (fotoBase64()) {
                                <img [src]="fotoBase64()" alt="Foto de perfil" class="w-full h-full object-cover" />
                            } @else {
                                <i class="pi pi-user text-4xl text-muted-color opacity-40"></i>
                            }
                        </div>
                        <label class="absolute bottom-0.5 right-0.5 w-8 h-8 rounded-full bg-primary shadow-md flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors" title="Alterar foto">
                            <i class="pi pi-camera text-white text-sm"></i>
                            <input type="file" accept="image/*" class="hidden" (change)="onFotoSelecionada($event)" />
                        </label>
                    </div>

                    <div class="flex-1 flex flex-col gap-2">
                        @if (sasSelecionado(); as sas) {
                            <div class="p-3 bg-surface-100 dark:bg-surface-800 rounded-lg flex items-center justify-between">
                                <div class="flex flex-col gap-0.5">
                                    <span class="font-semibold text-sm">{{ sas.nmSolicitante }}</span>
                                    <span class="text-xs text-muted-color">UF: {{ sas.sgUf }}</span>
                                </div>
                                <p-button icon="pi pi-pencil" ariaLabel="Trocar" severity="secondary" [text]="true" size="small" pTooltip="Trocar" (onClick)="voltarParaBusca()" />
                            </div>
                        }
                        <div class="flex flex-col gap-0.5">
                            <span class="text-xs text-muted-color">Foto de perfil</span>
                            <span class="text-xs text-muted-color/70">JPG, PNG ou GIF. Clique no ícone para alterar.</span>
                            @if (fotoBase64()) {
                                <p-button label="Remover" icon="pi pi-trash" severity="danger" [text]="true" size="small" styleClass="self-start -ml-2" (onClick)="removerFoto()" />
                            }
                        </div>
                    </div>
                </div>

                <p-divider styleClass="my-0" />

                <div class="grid grid-cols-2 gap-4">
                    <div class="flex flex-col gap-1 col-span-2">
                        <label class="text-sm font-medium">Nome do solicitante <span class="text-red-500">*</span></label>
                        <input pInputText formControlName="nmSolicitante" placeholder="Nome completo" class="w-full" />
                        @if (isInvalidV('nmSolicitante')) {
                            <small class="text-red-500">Obrigatório (máx. 70 caracteres).</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1 col-span-2">
                        <label class="text-sm font-medium">User ID (Keycloak) <span class="text-red-500">*</span></label>
                        <input pInputText formControlName="userId" placeholder="UUID do usuário no Keycloak" class="w-full" />
                        @if (lookupKeycloak() === 'buscando') {
                            <small class="text-muted-color"><i class="pi pi-spin pi-spinner mr-1"></i>Buscando no Keycloak…</small>
                        }
                        @if (lookupKeycloak() === 'nao-encontrado') {
                            <small class="texto-aviso">Sem conta no Keycloak — será criada ao informar o e-mail abaixo.</small>
                        }
                        @if (lookupKeycloak() === 'sem-cpf') {
                            <small class="texto-aviso">Solicitante sem CPF cadastrado — não é possível resolver/criar no Keycloak.</small>
                        }
                        @if (precisaInformarCpf()) {
                            <div class="mt-3">
                                <label class="block mb-2">CPF do solicitante <span class="text-red-500">*</span></label>
                                <input pInputText [ngModel]="cpfSolicitante()" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onCpfSolicitanteInput($event)" placeholder="000.000.000-00" maxlength="14" class="w-full" />
                                @if (cpfSolicitanteInvalido()) {
                                    <small class="text-red-500">CPF inválido.</small>
                                } @else {
                                    <small class="text-muted-color">Será gravado no cadastro do solicitante e usado para localizar a conta no Keycloak.</small>
                                }
                            </div>
                        }
                        @if (lookupKeycloak() === 'criando') {
                            <small class="text-muted-color"><i class="pi pi-spin pi-spinner mr-1"></i>Criando no Keycloak…</small>
                        }
                        @if (lookupKeycloak() === 'erro') {
                            <small class="text-red-500">Não foi possível consultar o Keycloak. Tente novamente.</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1 col-span-2">
                        <label class="text-sm font-medium"
                            >E-mail
                            @if (lookupKeycloak() === 'nao-encontrado') {
                                <span class="text-red-500">*</span>
                            }
                        </label>
                        <p-select
                            formControlName="email"
                            [options]="emailsSolicitante()"
                            [editable]="true"
                            placeholder="Escolha ou digite um e-mail"
                            emptyMessage="Nenhum e-mail cadastrado — digite um"
                            appendTo="body"
                            class="w-full"
                            (onBlur)="onEmailBlurVincular()"
                        />
                        @if (isInvalidV('email')) {
                            <small class="text-red-500">E-mail inválido (máx. 60 caracteres).</small>
                        }
                        @if (lookupKeycloak() === 'nao-encontrado') {
                            <small class="texto-aviso">Informe um e-mail e saia do campo para criar o usuário no Keycloak.</small>
                        }
                    </div>

                    <div class="flex flex-col gap-1 col-span-2">
                        <label class="text-sm font-medium">Biografia</label>
                        <textarea pTextarea formControlName="dsBiografia" rows="2" placeholder="Breve descrição..." class="w-full resize-none"></textarea>
                    </div>

                    <div class="flex flex-col gap-1">
                        <label class="text-sm font-medium">Status no Portal <span class="text-red-500">*</span></label>
                        <p-select formControlName="inAtivo" [options]="opcoesStatus" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                    </div>
                </div>

                <ng-container [ngTemplateOutlet]="blocoAgr" />

                @if (precisaCriarFuncionario()) {
                    <div [formGroup]="formFuncionario" class="flex flex-col gap-4 border-t border-surface-200 dark:border-surface-600 pt-4">
                        <div>
                            <div class="font-semibold text-sm">Dados do funcionário</div>
                            <small class="text-muted-color">Esta pessoa ainda não tem cadastro de funcionário; ele será criado junto com o acesso. Nenhum campo é obrigatório.</small>
                        </div>
                        <div class="grid grid-cols-2 gap-3">
                            <div>
                                <label class="block mb-2">Matrícula</label>
                                <input pInputText formControlName="nuMatricula" maxlength="5" class="w-full" />
                            </div>
                            <div>
                                <label class="block mb-2">Cargo</label>
                                <p-select formControlName="idCargo" [options]="opcoesCargos()" optionLabel="label" optionValue="value" placeholder="Selecione" [showClear]="true" appendTo="body" class="w-full" />
                            </div>
                            <div>
                                <label class="block mb-2">Data de nascimento</label>
                                <p-datepicker formControlName="dtNascimento" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
                            </div>
                            <div>
                                <label class="block mb-2">Data de admissão</label>
                                <p-datepicker formControlName="dtAdmissao" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
                            </div>
                            <div>
                                <label class="block mb-2">Data de afastamento</label>
                                <p-datepicker formControlName="dtAfastamento" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body" styleClass="w-full" />
                            </div>
                        </div>
                        <div class="flex gap-6">
                            <div class="flex items-center gap-2">
                                <p-toggleswitch [ngModel]="formFuncionario.controls.inConselheiro.value === 'S'" [ngModelOptions]="{ standalone: true }" (ngModelChange)="formFuncionario.controls.inConselheiro.setValue($event ? 'S' : 'N')" />
                                <label>Conselheiro</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <p-toggleswitch [ngModel]="formFuncionario.controls.inAscfm.value === 'S'" [ngModelOptions]="{ standalone: true }" (ngModelChange)="formFuncionario.controls.inAscfm.setValue($event ? 'S' : 'N')" />
                                <label>ASCFM</label>
                            </div>
                        </div>
                    </div>
                }
            </form>
        }
    }

    <!-- Formulário criar do zero -->
    @if (passo() === 'formulario-completo' && formCompleto) {
        <form [formGroup]="formCompleto" class="flex flex-col gap-5">
            <!-- Foto de perfil -->
            <div class="flex items-center gap-5">
                <div class="relative shrink-0">
                    <div class="w-24 h-24 rounded-full overflow-hidden border-4 border-surface-200 dark:border-surface-600 bg-surface-100 dark:bg-surface-800 flex items-center justify-center shadow-sm">
                        @if (fotoBase64()) {
                            <img [src]="fotoBase64()" alt="Foto de perfil" class="w-full h-full object-cover" />
                        } @else {
                            <i class="pi pi-user text-4xl text-muted-color opacity-40"></i>
                        }
                    </div>
                    <label class="absolute bottom-0.5 right-0.5 w-8 h-8 rounded-full bg-primary shadow-md flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors" title="Alterar foto">
                        <i class="pi pi-camera text-white text-sm"></i>
                        <input type="file" accept="image/*" class="hidden" (change)="onFotoSelecionada($event)" />
                    </label>
                </div>
                <div class="flex flex-col gap-0.5">
                    <span class="text-sm font-medium">Foto de perfil</span>
                    <span class="text-xs text-muted-color/70">JPG, PNG ou GIF. Clique no ícone para alterar.</span>
                    @if (fotoBase64()) {
                        <p-button label="Remover" icon="pi pi-trash" severity="danger" [text]="true" size="small" styleClass="self-start -ml-2" (onClick)="removerFoto()" />
                    }
                </div>
            </div>

            <p-divider align="left" styleClass="my-0">
                <span class="text-xs font-semibold uppercase tracking-wide text-muted-color">Dados pessoais</span>
            </p-divider>

            <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">UF <span class="text-red-500">*</span></label>
                    <p-select formControlName="uf" [options]="ufs" optionLabel="label" optionValue="value" placeholder="Selecione..." appendTo="body" class="w-full" />
                    @if (isInvalidC('uf')) {
                        <small class="text-red-500">UF é obrigatória.</small>
                    }
                </div>

                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">CPF <span class="text-red-500">*</span></label>
                    <input pInputText formControlName="cpf" placeholder="000.000.000-00" class="w-full" />
                    @if (isInvalidC('cpf')) {
                        <small class="text-red-500">CPF obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col gap-1 col-span-2">
                    <label class="text-sm font-medium">Nome completo <span class="text-red-500">*</span></label>
                    <input pInputText formControlName="nmSolicitante" placeholder="Nome do usuário" class="w-full" />
                    @if (isInvalidC('nmSolicitante')) {
                        <small class="text-red-500">Obrigatório (máx. 70 caracteres).</small>
                    }
                </div>

                <div class="flex flex-col gap-1 col-span-2">
                    <label class="text-sm font-medium"
                        >E-mail
                        @if (lookupKeycloak() === 'nao-encontrado') {
                            <span class="text-red-500">*</span>
                        }
                    </label>
                    <input pInputText formControlName="email" placeholder="email@exemplo.com" class="w-full" (blur)="onEmailBlurCompleto()" />
                    @if (isInvalidC('email')) {
                        <small class="text-red-500">E-mail inválido.</small>
                    }
                    @if (lookupKeycloak() === 'nao-encontrado') {
                        <small class="texto-aviso">Informe um e-mail e saia do campo para criar o usuário no Keycloak.</small>
                    }
                </div>
            </div>

            <p-divider align="left" styleClass="my-0">
                <span class="text-xs font-semibold uppercase tracking-wide text-muted-color">Acesso ao Portal</span>
            </p-divider>

            <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-medium">Status <span class="text-red-500">*</span></label>
                    <p-select formControlName="inAtivo" [options]="opcoesStatus" optionLabel="label" optionValue="value" appendTo="body" class="w-full" />
                    @if (isInvalidC('inAtivo')) {
                        <small class="text-red-500">Obrigatório.</small>
                    }
                </div>

                <div class="flex flex-col gap-1 col-span-2">
                    <label class="text-sm font-medium">User ID (Keycloak) <span class="text-red-500">*</span></label>
                    <input pInputText formControlName="userId" placeholder="UUID do usuário no Keycloak" class="w-full" />
                    @if (lookupKeycloak() === 'buscando') {
                        <small class="text-muted-color"><i class="pi pi-spin pi-spinner mr-1"></i>Buscando no Keycloak…</small>
                    }
                    @if (lookupKeycloak() === 'nao-encontrado') {
                        <small class="texto-aviso">Sem conta no Keycloak — será criada ao informar o e-mail.</small>
                    }
                    @if (lookupKeycloak() === 'criando') {
                        <small class="text-muted-color"><i class="pi pi-spin pi-spinner mr-1"></i>Criando no Keycloak…</small>
                    }
                    @if (lookupKeycloak() === 'erro') {
                        <small class="text-red-500">Não foi possível consultar o Keycloak. Tente novamente.</small>
                    }
                </div>

                <div class="flex flex-col gap-1 col-span-2">
                    <label class="text-sm font-medium">Biografia</label>
                    <textarea pTextarea formControlName="dsBiografia" rows="2" placeholder="Breve descrição..." class="w-full resize-none"></textarea>
                </div>
            </div>

            <ng-container [ngTemplateOutlet]="blocoAgr" />
        </form>
    }

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            @if (passo() !== 'selecionar-modo' && !modoEdicao) {
                <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" [text]="true" (onClick)="passo() === 'formulario-vincular' ? voltarParaBusca() : voltarParaModo()" />
            }
            <p-button label="Cancelar" severity="secondary" [text]="true" (onClick)="fechar()" />
            @if (passo() === 'formulario-vincular') {
                <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" [disabled]="!modoEdicao && lookupKeycloak() !== 'ok'" [appCan]="modoEdicao ? roleUsuariosEditar : roleUsuariosCriar" (onClick)="salvarVincular()" />
            }
            @if (passo() === 'formulario-completo') {
                <p-button label="Criar Usuário" icon="pi pi-user-plus" [loading]="salvando()" [disabled]="lookupKeycloak() !== 'ok'" [appCan]="roleUsuariosCriar" (onClick)="salvarCompleto()" />
            }
        </div>
    </ng-template>
</p-dialog>

<ng-template #blocoAgr>
    <div class="field mt-3">
        <label class="block mb-2">Agente de Registro (AGR)</label>
        <div class="flex items-center gap-2">
            <p-toggleswitch [ngModel]="agenteAgr() ?? false" [ngModelOptions]="{ standalone: true }" [disabled]="agrBloqueado() || salvandoAgr()" (ngModelChange)="onAgrChange($event)" />
            @if (motivoAgrBloqueado(); as motivo) {
                <small class="text-muted-color">{{ motivo }}</small>
            }
        </div>
    </div>
</ng-template>

<p-confirmDialog key="cpf-confirm" />
